import { setFullStoryUserProperties } from "@expert/monitoring";
import { useEffect } from "react";

import { useAgentStore } from "@/sdk/agent/store/agent.store";

/**
 * Attaches the agent's routing-profile capability (per-channel capacity + assigned queues) to the
 * FullStory user as session context - the same "extend the user" mechanism used for AD groups.
 * Informational only (no events), and updates reactively when the routing profile loads or changes,
 * so sessions carry the real channel/queue picture even as blended voice+chat support rolls out.
 */
export function useRoutingProfileMonitoring(): void {
    const channelCapacity = useAgentStore((state) => state.channelCapacity);
    const assignedQueues = useAgentStore((state) => state.assignedQueues);

    useEffect(() => {
        // Wait until the routing profile has actually populated the store.
        if (Object.keys(channelCapacity).length === 0) return;

        setFullStoryUserProperties({
            routingProfileVoiceCapacity: channelCapacity.voice ?? 0,
            routingProfileChatCapacity: channelCapacity.chat ?? 0,
            // Connect includes an unnamed agent personal queue (name is null); drop it.
            routingProfileQueues: assignedQueues.map((queue) => queue.name).filter(Boolean),
        });
    }, [channelCapacity, assignedQueues]);
}
